module.exports = __webpack_public_path__ + "static/media/축령산.413f9c9d.jpg";